export default {
  items: [
    {
      name: 'ホーム',
      icon: 'cil-home',
      url: '/home',
    },
    {
      name: 'マイカード',
      icon: 'cil-library',
      url: '/cards',
    },
    {
      name: 'ビジネスコンボ',
      icon: 'cil-notes',
      url: '/combo',
    },
    {
      name: 'コンボを投稿',
      icon: 'cil-plus',
      url: '/combo/new',
    },
    {
      name: 'カード図鑑',
      icon: 'cil-address-book',
      url: '/dictionary',
    },
  ],
};
